import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import { WhiteBox } from 'components/AppShell';
import { useNavigateWithClient } from 'hooks';
import CustomButton from 'components/CustomButton';
import NoAccessTooltip from 'components/NoAccessTooltip';
import { useSelectedBatchRemoved } from 'announcementStore';

const useStyles = makeStyles((theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    position: 'relative',
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    flex: 1,
  },
  icon: {
    fontSize: '40px',
    lineHeight: 1,
  },
}));

const ResumeGeneratorBanner = () => {
  const classes = useStyles();
  const navigateWithClient = useNavigateWithClient();
  const removed = useSelectedBatchRemoved();

  return (
    <WhiteBox sx={{ position: 'relative', overflow: 'hidden' }}>
      <img
        src='https://assets.languify.in/images/gradientBlue.png'
        alt='texture'
        width={300}
        height='100%'
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
        }}
      />
      <Box className={classes.banner}>
        <Box className={classes.contentSection}>
          <Typography variant='h5-semiBold' color='neutral.clr-900'>
            Build your professional resume in minutes
          </Typography>
          <Typography variant='body01-bold' color='neutral.clr-700'>
            Create a polished, job-ready resume with our easy-to-use resume
            builder. Fill in your details, choose a template, and download
            your resume instantly.
          </Typography>
          <NoAccessTooltip show={removed}>
            <CustomButton
              onClick={() =>
                navigateWithClient('/shortlisting-genie/resume-generator')
              }
              size='medium'
              sx={{ width: 'fit-content', marginTop: '4px' }}
              disabled={removed}
            >
              Build My Resume
            </CustomButton>
          </NoAccessTooltip>
        </Box>
      </Box>
    </WhiteBox>
  );
};

export default ResumeGeneratorBanner;
